import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import STARRED_FILTERS_QUERY, {
	type starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery,
} from '@atlassian/jira-relay/src/__generated__/starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery.graphql';
import { fg } from '@atlassian/jira-feature-gating';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

export const sidebarProjectIssuesResource = withGiraAggAnonSsrFix(
	createRelayResource<starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery>(
		{
			type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
			getQuery: (_, { tenantContext }) => ({
				parameters: STARRED_FILTERS_QUERY,
				variables: {
					cloudId: tenantContext.cloudId,
					...(fg('add_limit_to_nav3_starred_filter_sidebar') && {
						first: 15,
					}),
				},
				options: { fetchPolicy: 'store-and-network' },
			}),
		},
	),
);
